import React from 'react';
import { Topbar } from '../components/Topbar';
import { motion } from 'framer-motion';
import { UnavailableModule } from '../components/UnavailableModule';

export function HistoryPage() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Topbar />
      <UnavailableModule />
    </motion.div>
  );
}
